import { Component, OnInit } from "@angular/core";
import { DataService_MultiStationSettings } from "../shared/data.service";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { ScanStationSettingsUpdateRequest } from "../shared/ScanStationSettingsUpdateRequest";
import { ConfirmationService } from "primeng/api";

@Component({
	selector: "caass-multistation-station-settings",
	templateUrl: "./multistation-station-settings.component.html",
	styleUrls: ["./multistation-station-settings.component.css"],
})
export class MultistationStationSettingsComponent implements OnInit {
	constructor(
		private dataService: DataService_MultiStationSettings,
		private selectService: SchoolselectorService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	/////////////////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////////////////

	lstScanStation: any = [];
	SelectedScanStation: any;

	lstAllFacility: any = [];
	lstVisitorType: any = [];
	lstVisitReason: any = [];
	lstKeyboardMode: any = [];
	lstStationMode: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedSchool: any;
	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	lstFacility: any = [];
	SelectedFacility: any;

	subscription: any;

	StationLoading: boolean = false;
	FacilityLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	////////////////////////////////////
	//#region Filter Lists
	////////////////////////////////////

	lstCurrentVersion: any = [];
	lstOutOfDateDesc: any = [];
	lstUseDefaultValuesDesc: any = [];
	lstVisitorModeEnabledDesc: any = [];
	lstStudentModeEnabledDesc: any = [];
	lstStaffModeEnabledDesc: any = [];
	lstOffenderLookupEnabledDesc: any = [];
	lstPanicButtonEnabledDesc: any = [];
	lstConfirmPanicButtonEnabledDesc: any = [];
	lstPanicButtonText: any = [];
	lstConfirmPanicButtonText: any = [];
	lstSkipConfirmInfoDesc: any = [];
	lstPhotoRequiredDesc: any = [];
	lstSkipPhotoIfNotRequiredDesc: any = [];
	lstUseDriversLicensePhotoDesc: any = [];
	lstAllowExistingPhotoDesc: any = [];
	lstForceRetakePhotoAfterXDays: any = [];
	lstSkipVisitorTypeDesc: any = [];
	lstSkipVisiteeDesc: any = [];
	lstSkipVisitReasonDesc: any = [];
	lstSkipAdditionalNotesDesc: any = [];
	lstSkipSignatureDesc: any = [];
	lstUseDriversLicenseSignatureDesc: any = [];
	lstPrinterName: any = [];
	lstPrinterAlignTop: any = [];
	lstPrinterAlignLeft: any = [];
	lstPrintStudentLatePassesDesc: any = [];
	lstPrintStudentEntryPassesDesc: any = [];
	lstSelfCheckInVerifyText: any = [];
	lstHas2DScannerDesc: any = [];
	lstHasSingleSidedScannerDesc: any = [];
	lstHasDoubleSidedScannerDesc: any = [];
	lstHasRFIDReaderDesc: any = [];
	lstHasSignaturePadDesc: any = [];
	lstWebcamDeviceName: any = [];
	lstIsScanStationDesc: any = [];

	//#endregion
	////////////////////////////////////

	////////////////////////////////////
	//#region Show/Hide Columns
	////////////////////////////////////

	ShowScanStation: boolean = true;
	ShowCurrentVersion: boolean = true;
	ShowOutOfDateDesc: boolean = true;
	ShowFacilityID: boolean = true;
	ShowFacilityLocationID: boolean = true;
	ShowUseDefaultValues: boolean = true;
	ShowVisitorModeEnabled: boolean = true;
	ShowStudentModeEnabled: boolean = true;
	ShowStaffModeEnabled: boolean = true;
	ShowOffenderLookupEnabled: boolean = true;
	ShowPanicButtonEnabled: boolean = false;
	ShowConfirmPanicButtonEnabled: boolean = false;
	ShowPanicButtonText: boolean = false;
	ShowConfirmPanicButtonText: boolean = false;
	ShowPanicButtonTopicID: boolean = false;
	ShowSkipConfirmInfo: boolean = false;
	ShowPhotoRequired: boolean = false;
	ShowSkipPhotoIfNotRequired: boolean = false;
	ShowUseDriversLicensePhoto: boolean = false;
	ShowAllowExistingPhoto: boolean = false;
	ShowForceRetakePhotoAfterXDays: boolean = false;
	ShowSkipVisitorType: boolean = false;
	ShowDefaultVisitorTypeID: boolean = false;
	ShowSkipVisitee: boolean = false;
	ShowDefaultVisiteeID: boolean = false;
	ShowSkipVisitReason: boolean = false;
	ShowDefaultVisitReasonID: boolean = false;
	ShowSkipAdditionalNotes: boolean = false;
	ShowSkipSignature: boolean = false;
	ShowUseDriversLicenseSignature: boolean = false;
	ShowPrinterName: boolean = false;
	ShowPrinterAlignTop: boolean = false;
	ShowPrinterAlignLeft: boolean = false;
	ShowPrintStudentLatePasses: boolean = false;
	ShowPrintStudentEntryPasses: boolean = false;
	ShowTemplate_Default: boolean = false;
	ShowTemplate_VerificationReqd: boolean = false;
	ShowTemplate_OffenderHit: boolean = false;
	ShowSelfCheckInVerifyText: boolean = false;
	ShowKeyboardMode: boolean = false;
	ShowStationMode: boolean = false;
	ShowHas2DScanner: boolean = false;
	ShowHasSingleSidedScanner: boolean = false;
	ShowHasDoubleSidedScanner: boolean = false;
	ShowHasRFIDReader: boolean = false;
	ShowHasSignaturePad: boolean = false;
	ShowWebcamDeviceName: boolean = false;
	ShowVisitorScanCount: boolean = false;
	ShowLastVisitorDT: boolean = true;
	ShowLastLoginDT: boolean = false;
	Showc_Date: boolean = false;
	ShowSyncDropdownMinutes: boolean = false;
	ShowIsScanStation: boolean = false;

	//#endregion
	////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////////////////

	loadFacilities() {
		this.FacilityLoading = true;
		var result = this.dataService.MSFacilitySelectList(this.SelectedSchool.SchoolID);
		result.subscribe(
			(response) => {
				this.lstFacility = response;

				if (this.SelectedSchool.SchoolID <= 0) {
					this.lstFacility.unshift({
						FacilityID: -1,
						FacilityName: "All Facilities",
						HasLocations: true,
					});
				}

				this.onFacilityChange(this.lstFacility[0]);

				this.FacilityLoading = false;
			},
			(error) => {
				this.FacilityLoading = false;
			}
		);
	}

	loadData() {
		this.errorMessage = "";

		if (this.SelectedFacility == undefined || this.SelectedFacility.FacilityID == undefined) {
			return;
		}

		this.StationLoading = true;

		var result = this.dataService.StationSettingsTableSelectList(this.SelectedFacility.FacilityID);
		result.subscribe(
			(response: any) => {
				this.lstScanStation = response.lstStation;

				for (var z = 0; z < this.lstScanStation.length; z++) {
					var next = this.lstScanStation[z];

					for (var i = 0; i < next.lstIDCardTemplate.length; i++) {
						var nextIDCard = next.lstIDCardTemplate[i];

						if (String(next.Template_Default) == String(nextIDCard.IDCardTemplateID)) {
							next.Template_Default = nextIDCard.IDCardTemplateID;
						}
						if (String(next.Template_VerificationReqd) == String(nextIDCard.IDCardTemplateID)) {
							next.Template_VerificationReqd = nextIDCard.IDCardTemplateID;
						}
						if (String(next.Template_OffenderHit) == String(nextIDCard.IDCardTemplateID)) {
							next.Template_OffenderHit = nextIDCard.IDCardTemplateID;
						}
					}

					next.SelectedVisitee = null;
					if (next.lstVisitee.length > 0) {
						var vPerson = null;
						var vLocation = null;

						for (var i = 0; i < next.lstVisitee.length; i++) {
							var nextVisitee = next.lstVisitee[i];

							if (nextVisitee.VisiteeID == next.DefaultVisiteeID) {
								vPerson = nextVisitee;
							}
							if (nextVisitee.FacilityLocationID == next.DefaultVisiteeFacilityLocationID) {
								vLocation = nextVisitee;
							}
						}

						if (vPerson != null) {
							next.SelectedVisitee = vPerson;
						} else if (vLocation != null) {
							next.SelectedVisitee = vLocation;
						} else {
							next.SelectedVisitee = next.lstVisitee[i];
						}
					}

					if (next.PanicButtonTopicID <= 0 && next.lstPanicButtonTopic.length > 0) {
						next.PanicButtonTopicID = next.lstPanicButtonTopic[0].ID;
					}
				}

				//
				//#region Update Filter Lists
				//

				this.lstCurrentVersion = Array.from(new Set(this.lstScanStation.map((item: any) => item.CurrentVersion))).sort();
				this.lstOutOfDateDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.OutOfDateDesc))).sort();
				this.lstUseDefaultValuesDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.UseDefaultValuesDesc))).sort();
				this.lstVisitorModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.VisitorModeEnabledDesc))).sort();
				this.lstStudentModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.StudentModeEnabledDesc))).sort();
				this.lstStaffModeEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.StaffModeEnabledDesc))).sort();
				this.lstOffenderLookupEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.OffenderLookupEnabledDesc))).sort();
				this.lstPanicButtonEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.PanicButtonEnabledDesc))).sort();
				this.lstConfirmPanicButtonEnabledDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.ConfirmPanicButtonEnabledDesc))).sort();
				this.lstPanicButtonText = Array.from(new Set(this.lstScanStation.map((item: any) => item.PanicButtonText))).sort();
				this.lstConfirmPanicButtonText = Array.from(new Set(this.lstScanStation.map((item: any) => item.ConfirmPanicButtonText))).sort();
				this.lstSkipConfirmInfoDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipConfirmInfoDesc))).sort();
				this.lstPhotoRequiredDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.PhotoRequiredDesc))).sort();
				this.lstSkipPhotoIfNotRequiredDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipPhotoIfNotRequiredDesc))).sort();
				this.lstUseDriversLicensePhotoDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.UseDriversLicensePhotoDesc))).sort();
				this.lstAllowExistingPhotoDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.AllowExistingPhotoDesc))).sort();
				this.lstForceRetakePhotoAfterXDays = Array.from(new Set(this.lstScanStation.map((item: any) => item.ForceRetakePhotoAfterXDays))).sort();
				this.lstSkipVisitorTypeDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipVisitorTypeDesc))).sort();
				this.lstSkipVisiteeDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipVisiteeDesc))).sort();
				this.lstSkipVisitReasonDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipVisitReasonDesc))).sort();
				this.lstSkipAdditionalNotesDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipAdditionalNotesDesc))).sort();
				this.lstSkipSignatureDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.SkipSignatureDesc))).sort();
				this.lstUseDriversLicenseSignatureDesc = Array.from(
					new Set(this.lstScanStation.map((item: any) => item.UseDriversLicenseSignatureDesc))
				).sort();
				this.lstPrinterName = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrinterName))).sort();
				this.lstPrinterAlignTop = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrinterAlignTop))).sort();
				this.lstPrinterAlignLeft = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrinterAlignLeft))).sort();
				this.lstPrintStudentLatePassesDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrintStudentLatePassesDesc))).sort();
				this.lstPrintStudentEntryPassesDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.PrintStudentEntryPassesDesc))).sort();
				this.lstSelfCheckInVerifyText = Array.from(new Set(this.lstScanStation.map((item: any) => item.SelfCheckInVerifyText))).sort();
				this.lstHas2DScannerDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.Has2DScannerDesc))).sort();
				this.lstHasSingleSidedScannerDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.HasSingleSidedScannerDesc))).sort();
				this.lstHasDoubleSidedScannerDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.HasDoubleSidedScannerDesc))).sort();
				this.lstHasRFIDReaderDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.HasRFIDReaderDesc))).sort();
				this.lstHasSignaturePadDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.HasSignaturePadDesc))).sort();
				this.lstWebcamDeviceName = Array.from(new Set(this.lstScanStation.map((item: any) => item.WebcamDeviceName))).sort();
				this.lstIsScanStationDesc = Array.from(new Set(this.lstScanStation.map((item: any) => item.IsScanStationDesc))).sort();

				//#endregion
				//

				this.lstAllFacility = response.lstFacility;
				this.lstVisitorType = response.lstVisitorType;
				this.lstVisitReason = response.lstVisitReason;
				this.lstKeyboardMode = response.lstKeyboardMode;
				this.lstStationMode = response.lstStationMode;

				this.StationLoading = false;
			},
			(error) => {
				this.StationLoading = false;
			}
		);
	}

	loadScanStationIDCardTemplate(ScanStation) {
		ScanStation.IDCardTemplateLoading = true;

		var result = this.dataService.IDCardTemplateSelectList(ScanStation.FacilityID);
		result.subscribe(
			(response: any) => {
				ScanStation.lstIDCardTemplate = response;

				var DefaultFound = false;
				var VerificationReqFound = false;
				var OffenderHitFound = false;

				for (var i = 0; i < ScanStation.lstIDCardTemplate.length; i++) {
					var nextIDCard = ScanStation.lstIDCardTemplate[i];

					if (String(ScanStation.Template_Default) == String(nextIDCard.IDCardTemplateID)) {
						ScanStation.Template_Default = nextIDCard.IDCardTemplateID;
						DefaultFound = true;
					}
					if (String(ScanStation.Template_VerificationReqd) == String(nextIDCard.IDCardTemplateID)) {
						ScanStation.Template_VerificationReqd = nextIDCard.IDCardTemplateID;
						VerificationReqFound = true;
					}
					if (String(ScanStation.Template_OffenderHit) == String(nextIDCard.IDCardTemplateID)) {
						ScanStation.Template_OffenderHit = nextIDCard.IDCardTemplateID;
						OffenderHitFound = true;
					}
				}

				if (ScanStation.lstIDCardTemplate.length > 0) {
					if (DefaultFound == false) {
						ScanStation.Template_Default = ScanStation.lstIDCardTemplate[0].IDCardTemplateID;
					}
					if (VerificationReqFound == false) {
						ScanStation.Template_VerificationReqd = ScanStation.lstIDCardTemplate[0].IDCardTemplateID;
					}
					if (OffenderHitFound == false) {
						ScanStation.Template_OffenderHit = ScanStation.lstIDCardTemplate[0].IDCardTemplateID;
					}
				}

				ScanStation.IDCardTemplateLoading = false;
			},
			(error) => {
				ScanStation.IDCardTemplateLoading = false;
			}
		);
	}

	loadScanStationVisitee(ScanStation) {
		ScanStation.VisiteeLoading = true;

		var result = this.dataService.SettingsVisiteeSelectList(ScanStation.FacilityID);
		result.subscribe(
			(response: any) => {
				ScanStation.lstVisitee = response;

				if (ScanStation.lstVisitee.length > 0) {
					ScanStation.SelectedVisitee = ScanStation.lstVisitee[0];
				} else {
					ScanStation.DefaultVisiteeID = null;
				}

				ScanStation.VisiteeLoading = false;
			},
			(error) => {
				ScanStation.VisiteeLoading = false;
			}
		);
	}

	loadScanStationPanicButtonTopic(ScanStation) {
		ScanStation.PanicButtonTopicLoading = true;

		var result = this.dataService.SettingsPanicButtonTopicSelectList(ScanStation.FacilityID);
		result.subscribe(
			(response: any) => {
				ScanStation.lstPanicButtonTopic = response;

				if (ScanStation.lstPanicButtonTopic.length > 0) {
					ScanStation.PanicButtonTopicID = ScanStation.lstPanicButtonTopic[0].ID;
				} else {
					ScanStation.PanicButtonTopicID = -1;
				}

				ScanStation.PanicButtonTopicLoading = false;
			},
			(error) => {
				ScanStation.PanicButtonTopicLoading = false;
			}
		);
	}

	loadScanStationFacilityLocation(ScanStation) {
		ScanStation.FacilityLocationLoading = true;

		var result = this.dataService.SettingsFacilityLocationSelectList(ScanStation.FacilityID);
		result.subscribe(
			(response: any) => {
				ScanStation.lstFacilityLocation = response;

				if (ScanStation.lstFacilityLocation.length > 0) {
					ScanStation.FacilityLocationID = ScanStation.lstFacilityLocation[0].ID;
				} else {
					ScanStation.FacilityLocationID = -1;
				}

				ScanStation.FacilityLocationLoading = false;
			},
			(error) => {
				ScanStation.FacilityLocationLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadData();
	}

	onResetOptions() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = true;
		this.ShowOutOfDateDesc = true;
		this.ShowFacilityID = true;
		this.ShowFacilityLocationID = true;
		this.ShowUseDefaultValues = true;
		this.ShowVisitorModeEnabled = true;
		this.ShowStudentModeEnabled = true;
		this.ShowStaffModeEnabled = true;
		this.ShowOffenderLookupEnabled = true;
		this.ShowPanicButtonEnabled = false;
		this.ShowConfirmPanicButtonEnabled = false;
		this.ShowPanicButtonText = false;
		this.ShowConfirmPanicButtonText = false;
		this.ShowPanicButtonTopicID = false;
		this.ShowSkipConfirmInfo = false;
		this.ShowPhotoRequired = false;
		this.ShowSkipPhotoIfNotRequired = false;
		this.ShowUseDriversLicensePhoto = false;
		this.ShowAllowExistingPhoto = false;
		this.ShowForceRetakePhotoAfterXDays = false;
		this.ShowSkipVisitorType = false;
		this.ShowDefaultVisitorTypeID = false;
		this.ShowSkipVisitee = false;
		this.ShowDefaultVisiteeID = false;
		this.ShowSkipVisitReason = false;
		this.ShowDefaultVisitReasonID = false;
		this.ShowSkipAdditionalNotes = false;
		this.ShowSkipSignature = false;
		this.ShowUseDriversLicenseSignature = false;
		this.ShowPrinterName = false;
		this.ShowPrinterAlignTop = false;
		this.ShowPrinterAlignLeft = false;
		this.ShowPrintStudentLatePasses = false;
		this.ShowPrintStudentEntryPasses = false;
		this.ShowTemplate_Default = false;
		this.ShowTemplate_VerificationReqd = false;
		this.ShowTemplate_OffenderHit = false;
		this.ShowSelfCheckInVerifyText = false;
		this.ShowKeyboardMode = false;
		this.ShowStationMode = false;
		this.ShowHas2DScanner = false;
		this.ShowHasSingleSidedScanner = false;
		this.ShowHasDoubleSidedScanner = false;
		this.ShowHasRFIDReader = false;
		this.ShowHasSignaturePad = false;
		this.ShowWebcamDeviceName = false;
		this.ShowVisitorScanCount = false;
		this.ShowLastVisitorDT = true;
		this.ShowLastLoginDT = false;
		this.Showc_Date = false;
		this.ShowSyncDropdownMinutes = false;
		this.ShowIsScanStation = false;
	}

	onDeselectAllOptions() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = false;
		this.ShowOutOfDateDesc = false;
		this.ShowFacilityID = false;
		this.ShowFacilityLocationID = false;
		this.ShowUseDefaultValues = false;
		this.ShowVisitorModeEnabled = false;
		this.ShowStudentModeEnabled = false;
		this.ShowStaffModeEnabled = false;
		this.ShowOffenderLookupEnabled = false;
		this.ShowPanicButtonEnabled = false;
		this.ShowConfirmPanicButtonEnabled = false;
		this.ShowPanicButtonText = false;
		this.ShowConfirmPanicButtonText = false;
		this.ShowPanicButtonTopicID = false;
		this.ShowSkipConfirmInfo = false;
		this.ShowPhotoRequired = false;
		this.ShowSkipPhotoIfNotRequired = false;
		this.ShowUseDriversLicensePhoto = false;
		this.ShowAllowExistingPhoto = false;
		this.ShowForceRetakePhotoAfterXDays = false;
		this.ShowSkipVisitorType = false;
		this.ShowDefaultVisitorTypeID = false;
		this.ShowSkipVisitee = false;
		this.ShowDefaultVisiteeID = false;
		this.ShowSkipVisitReason = false;
		this.ShowDefaultVisitReasonID = false;
		this.ShowSkipAdditionalNotes = false;
		this.ShowSkipSignature = false;
		this.ShowUseDriversLicenseSignature = false;
		this.ShowPrinterName = false;
		this.ShowPrinterAlignTop = false;
		this.ShowPrinterAlignLeft = false;
		this.ShowPrintStudentLatePasses = false;
		this.ShowPrintStudentEntryPasses = false;
		this.ShowTemplate_Default = false;
		this.ShowTemplate_VerificationReqd = false;
		this.ShowTemplate_OffenderHit = false;
		this.ShowSelfCheckInVerifyText = false;
		this.ShowKeyboardMode = false;
		this.ShowStationMode = false;
		this.ShowHas2DScanner = false;
		this.ShowHasSingleSidedScanner = false;
		this.ShowHasDoubleSidedScanner = false;
		this.ShowHasRFIDReader = false;
		this.ShowHasSignaturePad = false;
		this.ShowWebcamDeviceName = false;
		this.ShowVisitorScanCount = false;
		this.ShowLastVisitorDT = false;
		this.ShowLastLoginDT = false;
		this.Showc_Date = false;
		this.ShowSyncDropdownMinutes = false;
		this.ShowIsScanStation = false;
	}

	onSelectAllOptions() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = true;
		this.ShowOutOfDateDesc = true;
		this.ShowFacilityID = true;
		this.ShowFacilityLocationID = true;
		this.ShowUseDefaultValues = true;
		this.ShowVisitorModeEnabled = true;
		this.ShowStudentModeEnabled = true;
		this.ShowStaffModeEnabled = true;
		this.ShowOffenderLookupEnabled = true;
		this.ShowPanicButtonEnabled = true;
		this.ShowConfirmPanicButtonEnabled = true;
		this.ShowPanicButtonText = true;
		this.ShowConfirmPanicButtonText = true;
		this.ShowPanicButtonTopicID = true;
		this.ShowSkipConfirmInfo = true;
		this.ShowPhotoRequired = true;
		this.ShowSkipPhotoIfNotRequired = true;
		this.ShowUseDriversLicensePhoto = true;
		this.ShowAllowExistingPhoto = true;
		this.ShowForceRetakePhotoAfterXDays = true;
		this.ShowSkipVisitorType = true;
		this.ShowDefaultVisitorTypeID = true;
		this.ShowSkipVisitee = true;
		this.ShowDefaultVisiteeID = true;
		this.ShowSkipVisitReason = true;
		this.ShowDefaultVisitReasonID = true;
		this.ShowSkipAdditionalNotes = true;
		this.ShowSkipSignature = true;
		this.ShowUseDriversLicenseSignature = true;
		this.ShowPrinterName = true;
		this.ShowPrinterAlignTop = true;
		this.ShowPrinterAlignLeft = true;
		this.ShowPrintStudentLatePasses = true;
		this.ShowPrintStudentEntryPasses = true;
		this.ShowTemplate_Default = true;
		this.ShowTemplate_VerificationReqd = true;
		this.ShowTemplate_OffenderHit = true;
		this.ShowSelfCheckInVerifyText = true;
		this.ShowKeyboardMode = true;
		this.ShowStationMode = true;
		this.ShowHas2DScanner = true;
		this.ShowHasSingleSidedScanner = true;
		this.ShowHasDoubleSidedScanner = true;
		this.ShowHasRFIDReader = true;
		this.ShowHasSignaturePad = true;
		this.ShowWebcamDeviceName = true;
		this.ShowVisitorScanCount = true;
		this.ShowLastVisitorDT = true;
		this.ShowLastLoginDT = true;
		this.Showc_Date = true;
		this.ShowSyncDropdownMinutes = true;
		this.ShowIsScanStation = true;
	}

	onShowModes() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = false;
		this.ShowOutOfDateDesc = false;
		this.ShowFacilityID = false;
		this.ShowFacilityLocationID = false;
		this.ShowUseDefaultValues = false;
		this.ShowVisitorModeEnabled = true;
		this.ShowStudentModeEnabled = true;
		this.ShowStaffModeEnabled = true;
		this.ShowOffenderLookupEnabled = true;
		this.ShowPanicButtonEnabled = false;
		this.ShowConfirmPanicButtonEnabled = false;
		this.ShowPanicButtonText = false;
		this.ShowConfirmPanicButtonText = false;
		this.ShowPanicButtonTopicID = false;
		this.ShowSkipConfirmInfo = false;
		this.ShowPhotoRequired = false;
		this.ShowSkipPhotoIfNotRequired = false;
		this.ShowUseDriversLicensePhoto = false;
		this.ShowAllowExistingPhoto = false;
		this.ShowForceRetakePhotoAfterXDays = false;
		this.ShowSkipVisitorType = false;
		this.ShowDefaultVisitorTypeID = false;
		this.ShowSkipVisitee = false;
		this.ShowDefaultVisiteeID = false;
		this.ShowSkipVisitReason = false;
		this.ShowDefaultVisitReasonID = false;
		this.ShowSkipAdditionalNotes = false;
		this.ShowSkipSignature = false;
		this.ShowUseDriversLicenseSignature = false;
		this.ShowPrinterName = false;
		this.ShowPrinterAlignTop = false;
		this.ShowPrinterAlignLeft = false;
		this.ShowPrintStudentLatePasses = false;
		this.ShowPrintStudentEntryPasses = false;
		this.ShowTemplate_Default = false;
		this.ShowTemplate_VerificationReqd = false;
		this.ShowTemplate_OffenderHit = false;
		this.ShowSelfCheckInVerifyText = false;
		this.ShowKeyboardMode = false;
		this.ShowStationMode = false;
		this.ShowHas2DScanner = false;
		this.ShowHasSingleSidedScanner = false;
		this.ShowHasDoubleSidedScanner = false;
		this.ShowHasRFIDReader = false;
		this.ShowHasSignaturePad = false;
		this.ShowWebcamDeviceName = false;
		this.ShowVisitorScanCount = false;
		this.ShowLastVisitorDT = false;
		this.ShowLastLoginDT = false;
		this.Showc_Date = false;
		this.ShowSyncDropdownMinutes = false;
		this.ShowIsScanStation = false;
	}

	onShowSkipPages() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = false;
		this.ShowOutOfDateDesc = false;
		this.ShowFacilityID = false;
		this.ShowFacilityLocationID = false;
		this.ShowUseDefaultValues = false;
		this.ShowVisitorModeEnabled = false;
		this.ShowStudentModeEnabled = false;
		this.ShowStaffModeEnabled = false;
		this.ShowOffenderLookupEnabled = false;
		this.ShowPanicButtonEnabled = false;
		this.ShowConfirmPanicButtonEnabled = false;
		this.ShowPanicButtonText = false;
		this.ShowConfirmPanicButtonText = false;
		this.ShowPanicButtonTopicID = false;
		this.ShowSkipConfirmInfo = true;
		this.ShowPhotoRequired = true;
		this.ShowSkipPhotoIfNotRequired = true;
		this.ShowUseDriversLicensePhoto = true;
		this.ShowAllowExistingPhoto = true;
		this.ShowForceRetakePhotoAfterXDays = true;
		this.ShowSkipVisitorType = true;
		this.ShowDefaultVisitorTypeID = true;
		this.ShowSkipVisitee = true;
		this.ShowDefaultVisiteeID = true;
		this.ShowSkipVisitReason = true;
		this.ShowDefaultVisitReasonID = true;
		this.ShowSkipAdditionalNotes = true;
		this.ShowSkipSignature = true;
		this.ShowUseDriversLicenseSignature = true;
		this.ShowPrinterName = false;
		this.ShowPrinterAlignTop = false;
		this.ShowPrinterAlignLeft = false;
		this.ShowPrintStudentLatePasses = false;
		this.ShowPrintStudentEntryPasses = false;
		this.ShowTemplate_Default = false;
		this.ShowTemplate_VerificationReqd = false;
		this.ShowTemplate_OffenderHit = false;
		this.ShowSelfCheckInVerifyText = false;
		this.ShowKeyboardMode = false;
		this.ShowStationMode = false;
		this.ShowHas2DScanner = false;
		this.ShowHasSingleSidedScanner = false;
		this.ShowHasDoubleSidedScanner = false;
		this.ShowHasRFIDReader = false;
		this.ShowHasSignaturePad = false;
		this.ShowWebcamDeviceName = false;
		this.ShowVisitorScanCount = false;
		this.ShowLastVisitorDT = false;
		this.ShowLastLoginDT = false;
		this.Showc_Date = false;
		this.ShowSyncDropdownMinutes = false;
		this.ShowIsScanStation = false;
	}

	onShowPanicButton() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = false;
		this.ShowOutOfDateDesc = false;
		this.ShowFacilityID = false;
		this.ShowFacilityLocationID = false;
		this.ShowUseDefaultValues = false;
		this.ShowVisitorModeEnabled = false;
		this.ShowStudentModeEnabled = false;
		this.ShowStaffModeEnabled = false;
		this.ShowOffenderLookupEnabled = false;
		this.ShowPanicButtonEnabled = true;
		this.ShowConfirmPanicButtonEnabled = true;
		this.ShowPanicButtonText = true;
		this.ShowConfirmPanicButtonText = true;
		this.ShowPanicButtonTopicID = true;
		this.ShowSkipConfirmInfo = false;
		this.ShowPhotoRequired = false;
		this.ShowSkipPhotoIfNotRequired = false;
		this.ShowUseDriversLicensePhoto = false;
		this.ShowAllowExistingPhoto = false;
		this.ShowForceRetakePhotoAfterXDays = false;
		this.ShowSkipVisitorType = false;
		this.ShowDefaultVisitorTypeID = false;
		this.ShowSkipVisitee = false;
		this.ShowDefaultVisiteeID = false;
		this.ShowSkipVisitReason = false;
		this.ShowDefaultVisitReasonID = false;
		this.ShowSkipAdditionalNotes = false;
		this.ShowSkipSignature = false;
		this.ShowUseDriversLicenseSignature = false;
		this.ShowPrinterName = false;
		this.ShowPrinterAlignTop = false;
		this.ShowPrinterAlignLeft = false;
		this.ShowPrintStudentLatePasses = false;
		this.ShowPrintStudentEntryPasses = false;
		this.ShowTemplate_Default = false;
		this.ShowTemplate_VerificationReqd = false;
		this.ShowTemplate_OffenderHit = false;
		this.ShowSelfCheckInVerifyText = false;
		this.ShowKeyboardMode = false;
		this.ShowStationMode = false;
		this.ShowHas2DScanner = false;
		this.ShowHasSingleSidedScanner = false;
		this.ShowHasDoubleSidedScanner = false;
		this.ShowHasRFIDReader = false;
		this.ShowHasSignaturePad = false;
		this.ShowWebcamDeviceName = false;
		this.ShowVisitorScanCount = false;
		this.ShowLastVisitorDT = false;
		this.ShowLastLoginDT = false;
		this.Showc_Date = false;
		this.ShowSyncDropdownMinutes = false;
		this.ShowIsScanStation = false;
	}

	onShowPrinterSettings() {
		this.ShowScanStation = true;
		this.ShowCurrentVersion = false;
		this.ShowOutOfDateDesc = false;
		this.ShowFacilityID = false;
		this.ShowFacilityLocationID = false;
		this.ShowUseDefaultValues = false;
		this.ShowVisitorModeEnabled = false;
		this.ShowStudentModeEnabled = false;
		this.ShowStaffModeEnabled = false;
		this.ShowOffenderLookupEnabled = false;
		this.ShowPanicButtonEnabled = false;
		this.ShowConfirmPanicButtonEnabled = false;
		this.ShowPanicButtonText = false;
		this.ShowConfirmPanicButtonText = false;
		this.ShowPanicButtonTopicID = false;
		this.ShowSkipConfirmInfo = false;
		this.ShowPhotoRequired = false;
		this.ShowSkipPhotoIfNotRequired = false;
		this.ShowUseDriversLicensePhoto = false;
		this.ShowAllowExistingPhoto = false;
		this.ShowForceRetakePhotoAfterXDays = false;
		this.ShowSkipVisitorType = false;
		this.ShowDefaultVisitorTypeID = false;
		this.ShowSkipVisitee = false;
		this.ShowDefaultVisiteeID = false;
		this.ShowSkipVisitReason = false;
		this.ShowDefaultVisitReasonID = false;
		this.ShowSkipAdditionalNotes = false;
		this.ShowSkipSignature = false;
		this.ShowUseDriversLicenseSignature = false;
		this.ShowPrinterName = true;
		this.ShowPrinterAlignTop = true;
		this.ShowPrinterAlignLeft = true;
		this.ShowPrintStudentLatePasses = true;
		this.ShowPrintStudentEntryPasses = true;
		this.ShowTemplate_Default = true;
		this.ShowTemplate_VerificationReqd = true;
		this.ShowTemplate_OffenderHit = true;
		this.ShowSelfCheckInVerifyText = false;
		this.ShowKeyboardMode = false;
		this.ShowStationMode = false;
		this.ShowHas2DScanner = false;
		this.ShowHasSingleSidedScanner = false;
		this.ShowHasDoubleSidedScanner = false;
		this.ShowHasRFIDReader = false;
		this.ShowHasSignaturePad = false;
		this.ShowWebcamDeviceName = false;
		this.ShowVisitorScanCount = false;
		this.ShowLastVisitorDT = false;
		this.ShowLastLoginDT = false;
		this.Showc_Date = false;
		this.ShowSyncDropdownMinutes = false;
		this.ShowIsScanStation = false;
	}

	onUpdateStation(ScanStation) {
		this.errorMessage = "";

		this.Processing = true;

		var parms: ScanStationSettingsUpdateRequest = {
			ScanStationID: ScanStation.ScanStationID,
			FacilityID: ScanStation.FacilityID,
			FacilityLocationID: ScanStation.FacilityLocationID,
			UseDefaultValues: ScanStation.UseDefaultValues,
			VisitorModeEnabled: ScanStation.VisitorModeEnabled,
			StudentModeEnabled: ScanStation.StudentModeEnabled,
			StaffModeEnabled: ScanStation.StaffModeEnabled,
			OffenderLookupEnabled: ScanStation.OffenderLookupEnabled,
			PanicButtonEnabled: ScanStation.PanicButtonEnabled,
			ConfirmPanicButtonEnabled: ScanStation.ConfirmPanicButtonEnabled,
			PanicButtonText: ScanStation.PanicButtonText,
			ConfirmPanicButtonText: ScanStation.ConfirmPanicButtonText,
			PanicButtonTopicID: ScanStation.PanicButtonTopicID,
			SkipConfirmInfo: ScanStation.SkipConfirmInfo,
			PhotoRequired: ScanStation.PhotoRequired,
			SkipPhotoIfNotRequired: ScanStation.SkipPhotoIfNotRequired,
			UseDriversLicensePhoto: ScanStation.UseDriversLicensePhoto,
			AllowExistingPhoto: ScanStation.AllowExistingPhoto,
			ForceRetakePhotoAfterXDays: ScanStation.ForceRetakePhotoAfterXDays,
			SkipVisitorType: ScanStation.SkipVisitorType,
			DefaultVisitorTypeID: ScanStation.DefaultVisitorTypeID,
			SkipVisitee: ScanStation.SkipVisitee,
			DefaultVisiteeSchoolID: ScanStation.SelectedVisitee.SchoolID,
			DefaultVisiteeID: ScanStation.SelectedVisitee.VisiteeID,
			DefaultVisiteeFacilityLocationID: ScanStation.SelectedVisitee.FacilityLocationID,
			SkipVisitReason: ScanStation.SkipVisitReason,
			DefaultVisitReasonID: ScanStation.DefaultVisitReasonID,
			SkipAdditionalNotes: ScanStation.SkipAdditionalNotes,
			SkipSignature: ScanStation.SkipSignature,
			UseDriversLicenseSignature: ScanStation.UseDriversLicenseSignature,
			PrinterAlignTop: ScanStation.PrinterAlignTop,
			PrinterAlignLeft: ScanStation.PrinterAlignLeft,
			PrintStudentLatePasses: ScanStation.PrintStudentLatePasses,
			PrintStudentEntryPasses: ScanStation.PrintStudentEntryPasses,
			Template_Default: ScanStation.Template_Default,
			Template_VerificationReqd: ScanStation.Template_VerificationReqd,
			Template_OffenderHit: ScanStation.Template_OffenderHit,
			SelfCheckInVerifyText: ScanStation.SelfCheckInVerifyText,
			KeyboardMode: ScanStation.KeyboardMode,
			StationMode: ScanStation.StationMode,
			SyncDropdownMinutes: ScanStation.SyncDropdownMinutes,
		};

		var result = this.dataService.ScanStationSettingsUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "station",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "ScanStation Settings were updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadData();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "station",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update scanstation settings: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.SelectedSchool = val;

		this.loadFacilities();
	}

	onFacilityChange(val) {
		this.SelectedFacility = val;

		this.loadData();
	}

	onScanStationFacilityChange(val, ScanStation) {
		ScanStation.FacilityID = val;

		ScanStation.IDCardTemplateLoading = true;
		ScanStation.VisiteeLoading = true;
		ScanStation.PanicButtonTopicLoading = true;
		ScanStation.FacilityLocationLoading = true;

		this.loadScanStationIDCardTemplate(ScanStation);
		this.loadScanStationVisitee(ScanStation);
		this.loadScanStationPanicButtonTopic(ScanStation);
		this.loadScanStationFacilityLocation(ScanStation);
	}

	/////////////////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.StationLoading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////////////////////
}
